import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Grid } from '@mui/material';
import { pick } from 'lodash';

import { navSections, useRegisterSection } from 'components/OnePageTemplates/common';
import { useDataContext } from 'components/OnePageTemplates/context';
import { getUrlWithoutProtocol } from 'components/OnePageTemplates/helpers/getUrlWithoutProtocol';

import { hasMeaningfulValues } from 'helpers/hasMeaningfulValues';

import styles from './ContactsSection.module.scss';

export const ContactsSection: React.FC = () => {
  const { isExtendedPreview, data } = useDataContext();
  const { t } = useTranslation();
  const registerNavSection = useRegisterSection(navSections.contacts);

  const sectionData = pick(data, ['contacts']);

  if (!isExtendedPreview && !hasMeaningfulValues(pick(sectionData.contacts, ['email', 'phone', 'websiteUrl']))) {
    return null;
  }

  if (!hasMeaningfulValues(sectionData)) {
    return null;
  }

  return (
    <Box {...registerNavSection} className={styles.contacts}>
      <Box className={styles.wrapper}>
        <Box className={styles.contactsContainer}>
          <Box className={styles.title}>{t('onePageMapping.contacts')}</Box>
          <Grid container spacing={2}>
            {data.contacts.websiteUrl && (
              <Grid item xs={12}>
                <a
                  href={data.contacts.websiteUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.infoText}
                >
                  {getUrlWithoutProtocol(data.contacts.websiteUrl)}
                </a>
              </Grid>
            )}
            {data.contacts.phone && (
              <Grid item xs={12}>
                <a href={`tel:+${data.contacts.phone}`} className={styles.infoText}>
                  +{data.contacts.phone}
                </a>
              </Grid>
            )}
            {data.contacts.email && (
              <Grid item xs={12}>
                <a href={`mailto:${data.contacts.email}`} className={styles.infoText}>
                  {data.contacts.email}
                </a>
              </Grid>
            )}
            {isExtendedPreview && data.contacts.address && (
              <Grid item xs={12}>
                {<address className={styles.infoText}>{data.contacts.address}</address>}
              </Grid>
            )}
            {isExtendedPreview && data.contacts.fullNameWithPos && (
              <Grid item xs={12}>
                <Box className={styles.infoText}>{data.contacts.fullNameWithPos}</Box>
              </Grid>
            )}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};
